import { render } from "./FeedbackAdmin.vue?vue&type=template&id=225d1f12&scoped=true"
import script from "./FeedbackAdmin.vue?vue&type=script&lang=js"
export * from "./FeedbackAdmin.vue?vue&type=script&lang=js"

import "./FeedbackAdmin.vue?vue&type=style&index=0&id=225d1f12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225d1f12"]])

export default __exports__